import { Navigate, useParams } from 'react-router-dom';
import { useCurrentTeam } from '@/providers/TeamProvider';
import { useSalesOrder } from '@/hooks/api/1260_sales_order';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { useEffect } from 'react';
import { toastError } from '@/lib/toast';

type Props = { children?: React.ReactNode };

export const RequireSalesOrder = ({ children }: Props) => {
  const { identifier, team_id, sales_order_id } = useParams();
  const { me } = useCurrentTeam();
  const { data, status } = useSalesOrder({
    identifier: identifier!,
    team_id: Number(team_id!),
    id: Number(sales_order_id!),
  });
  const { _so_, set_so_, meSalesOrderMember, setMeSalesOrderMember } = useCurrentSalesOrder();

  useEffect(() => {
    if (data) {
      set_so_((_) => data);
      setMeSalesOrderMember((_) => data.sales_order_members.find((m) => m.user.id == me!.id));
    }
  }, [data]);

  if (status == 'error') {
    toastError('アクセス出来ませんでした。');
    return <Navigate replace to={`/w/${identifier}`} />;
  }

  if (_so_) {
    return <>{children}</>;
  }

  return <></>;
};
